/**
 * API Service Layer
 * All backend communication centralized here
 */
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE,
  timeout: 10000,
  headers: { 'Content-Type': 'application/json' }
});

// Response interceptor for consistent error handling
api.interceptors.response.use(
  res => res.data,
  err => {
    const message = err.response?.data?.error || err.message || 'Network error';
    return Promise.reject(new Error(message));
  }
);

// ─── Algorithm APIs ───────────────────────────────────────────────────────
export const algorithmService = {
  getAll: (params = {}) => api.get('/algorithms', { params }),
  getById: (id) => api.get(`/algorithms/${id}`),
};

// ─── Category APIs ────────────────────────────────────────────────────────
export const categoryService = {
  getAll: () => api.get('/categories'),
};

// ─── Problem APIs ─────────────────────────────────────────────────────────
export const problemService = {
  getAll: (params = {}) => api.get('/problems', { params }),
  getById: (id) => api.get(`/problems/${id}`),
};

// ─── Code Execution ───────────────────────────────────────────────────────
export const codeService = {
  run: (code, problemId, testCaseId = null) =>
    api.post('/run-code', { code, problemId, testCaseId }),
};

export default api;
